import { Checkbox } from "@/components/ui/checkbox";
import { REVIEW_TAGS } from "@/services/adminProgramNews";
import { cn } from "@/lib/utils";

interface ReviewTagChipsProps {
  selected: string[];
  onToggle: (tag: string) => void;
  /** Suppressed articles lead with "Should not have been thrown out". */
  suppressed?: boolean;
}

const PROMINENT = "should-not-be-suppressed";

const ReviewTagChips = ({ selected, onToggle, suppressed = false }: ReviewTagChipsProps) => {
  const tags = suppressed
    ? [...REVIEW_TAGS].sort((a, b) => Number(b.value === PROMINENT) - Number(a.value === PROMINENT))
    : REVIEW_TAGS;

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map(tag => {
        const id = `review-tag-${tag.value}`;
        const prominent = suppressed && tag.value === PROMINENT;
        return (
          <label
            key={tag.value}
            htmlFor={id}
            className={cn(
              "inline-flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1 text-sm",
              selected.includes(tag.value) && "bg-secondary",
              prominent && "border-primary font-medium"
            )}
          >
            <Checkbox
              id={id}
              checked={selected.includes(tag.value)}
              onCheckedChange={() => onToggle(tag.value)}
            />
            {tag.label}
          </label>
        );
      })}
    </div>
  );
};

export default ReviewTagChips;
